import styled from '@emotion/styled';

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const EmailCard = styled.div`
  background: var(--white);
  border: 1px solid var(--border1);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EmailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border1);
`;

export const RecipientName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: var(--neut1);
`;

export const EmailDetail = styled.div`
  display: flex;
  gap: 8px;
  font-size: 14px;
`;

export const Label = styled.span`
  color: var(--neut3);
  font-weight: 500;
  min-width: 70px;
`;

export const Value = styled.span`
  color: var(--neut1);
  word-break: break-word;
`;
